import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import { productCatelogueJson } from "../../../DynamicFormsJson/MastersJSON/productCatelogue";
import { getproductCatelogue } from "../../../Slice/productCatelogue.slice";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { withRouter } from "../../../components/withRouter";
import { productCatelogueColumns } from "../../../tableColumns/table-columns";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import endpoint from "../../../config/endpoints";
import { apiGet, apiPost } from "../../../utils/api_service";
import { noInternetMsg, serverMsg, statusmsg } from "../../../config/messageconstant";
import { imageUrl } from "../../../config/Url";
class ProductCatelogueList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {},
        };
    }

    onChangeStatus = (rowData) => {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            let status = "";
            if (rowData.isActive == 0) {
                status = 1;
            } else {
                status = 0;
            }
            showLoador({ loador: true });
            apiPost({
                url: endpoint.productCatelogue + "/update-is-active?id=" + rowData.id +
                    "&status=" + status,
            }).then(({ data, success }) => {
                showLoador({ loador: false });
                if (success) {
                    showNotification({ msg: statusmsg });
                    window.location.reload();
                }
            });
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }

    };

    rowView = (rowData) => {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            if (rowData.id) {
                showLoador({ loador: true });
                apiGet({
                    url: productCatelogueJson.apiBaseURL + "/" + rowData.id,
                }).then(({ data, success }) => {
                    showLoador({ loador: false });
                    if (success) {
                        if (!data.error) {
                            if (data.data !== null && data.data.type !== null) {
                                if (data.data.type == 0) {
                                    window.location.replace("/product-catelogue-view/" + rowData.id)
                                } else {
                                    window.open(imageUrl + data.data.productImage, '_blank')
                                }
                            }
                        } else {
                            showNotification({ msg: serverMsg, severity: "error" });
                        }
                    } else {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });
            }
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }

    render() {
        const { productCatelogueList, getproductCatelogue } = this.props;
        const { dynamicMasterData } = this.state;
        return (
            <>
                <DynamicMainScreen
                    dynamicMasterData={dynamicMasterData}
                    formPath={productCatelogueJson.formPath}
                    screenTitle={productCatelogueJson.screenTitle}
                    showPdfDownload={false}
                    showExcelDownload={false}
                    showExtension={false}
                    pdfFileName={false}
                    showViewButtonInTable={true}
                    staticView={true}
                    rowView={this.rowView}
                    showAddButton={productCatelogueJson.showAddButton}
                    tableColumnsToFilter={productCatelogueJson.tableColumnsToFilter}
                    tableColumns={productCatelogueColumns}
                    tableData={productCatelogueList?.productCatelogue}
                    getTableData={getproductCatelogue}
                    getTableDataById={true}
                    apiBaseURL={productCatelogueJson.apiBaseURL}
                    baseIdColumn={productCatelogueJson.baseIdColumn}
                    showDeleteIcon={true}
                    isActiveURLFalse={true}
                    isActiveURLFalseMethod={this.onChangeStatus}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    productCatelogueList: state.productCatelogue,
});
const mapDispatchToProps = {
    showNotification,
    showLoador,
    getproductCatelogue,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(ProductCatelogueList);
